export default {
  es: {
    manageRoles: 'Gestión de roles',
    managePerms: 'Gestión de permisos',
    manageParams: 'Gestión de parámetros',
    manageUsers: 'Gestión de usuarios',
    managePatients: 'Gestión de pacientes',
    manageProfiles: 'Gestión de perfiles',
    viewItem: 'Ver ítem',
    editItem: 'Editar ítem',
    nephro: 'Nefrología',
    createUser: 'Crear usuario',
    patient: 'Paciente',
    hello: 'Hola',
    missedAppointments: 'Incumplimiento de citas por estadío'
  },
  en: {
    manageRoles: 'Roles management',
    managePerms: 'Permissions management',
    manageParams: 'Parameters management',
    manageUsers: 'Users management',
    managePatients: 'Patients management',
    manageProfiles: 'Profiles management',
    viewItem: 'View item',
    editItem: 'Edit item',
    nephro: 'Nephrology',
    createUser: 'Create user',
    patient: 'Patient',
    hello: 'Hello',
    missedAppointments: 'Missed appointments by stage'
  }
};
